import {createContext} from 'react'

import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

export type AlternativeOffersContextType = {
  showTotalPrices?: boolean
  onOfferClick?: (offer: SearchOffer) => void
  lang: string
  anonymousId: string
  onOfferViewed?: (offer: SearchOffer) => void
}

export const AlternativeOffersContext =
  createContext<AlternativeOffersContextType>({
    showTotalPrices: false,
    onOfferClick: () => {},
    lang: '',
    anonymousId: '',
    onOfferViewed: () => {}
  })
